// from https://github.com/acdlite/recompose/tree/master/src/packages/recompose

/* eslint-disable no-console */
import {Component, createElement} from 'react'

/**
 * [dr] createFactory is deprecated since react 16.13.1
 * see https://github.com/facebook/react/blob/22cab1cbd6ad52925828643c8c6d0d4fd7890c54/packages/react/src/ReactElement.js#L440
 * Return a function that produces ReactElements of a given type.
 * See https://reactjs.org/docs/react-api.html#createfactory
 */
export function createFactory(type) {
  const factory = createElement.bind(null, type)
  factory.type = type
  return factory
}

export const compose = (...funcs) => funcs.reduce((a, b) => (...args) => a(b(...args)), arg => arg)

const setStatic = (key, value) => BaseComponent => {
  /* eslint-disable no-param-reassign */
  BaseComponent[key] = value
  /* eslint-enable no-param-reassign */
  return BaseComponent
}

export const getDisplayName = Component => {
  if (typeof Component === 'string') {
    return Component
  }

  if (!Component) {
    return undefined
  }

  return Component.displayName || Component.name || 'Component'
}

const wrapDisplayName = (BaseComponent, hocName) => `${hocName}(${getDisplayName(BaseComponent)})`

const setDisplayName = displayName => setStatic('displayName', displayName)

export const lifecycle = spec => BaseComponent => {
  const factory = createFactory(BaseComponent)

  if (process.env.NODE_ENV !== 'production' && spec.hasOwnProperty('render')) {
    console.error(
      'lifecycle() does not support the render method; its behavior is to ' +
        'pass all props and state to the base component.'
    )
  }

  class Lifecycle extends Component {
    render() {
      return factory({
        ...this.props,
        ...this.state,
      })
    }
  }

  Object.keys(spec).forEach(hook => (Lifecycle.prototype[hook] = spec[hook]))

  if (process.env.NODE_ENV !== 'production') {
    return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle)
  }
  return Lifecycle
}
